import { AttributeType, SugarAttributeInfo } from "../../Suggester/SugarElementInfo";

export const classNameAttribute: SugarAttributeInfo = {
    name: "className",
    valueTypes: [AttributeType.CssClassName],
};
